<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="添加菜品分类"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form ref="forms" style="margin-top: 1.5rem">
            <van-field
                    v-model="name"
                    label="菜品分类名称"
                    required
                    name="菜品分类名称"
                    clearable
                    placeholder="请输入菜品分类名称"
                    :rules="[{ required: true, message: '菜品分类名称不能为空' }]"
            />
			<!-- <van-field name="uploader" label="菜品分类图片">
                <template #input>
                    <van-uploader :after-read="afterRead" v-model="imageList"   multiple :max-count="1"  />
                </template>
            </van-field> -->
			
			<van-field
			        v-model="rank"
			        label="排序值"
			        name="排序值"
			        clearable
			        placeholder="请输入排序值"
			/>

        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
		
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    export default {
        name: "FoodClassAdd",
        data() {
            return {
                imageList: [],
                name: '',
				rank:'',
            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
			afterRead(file) {
                this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
                        localData:file.content,
                        openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.image=response.data.local_img
                    }
                })
            },


            // 左侧返回
            onClickLeft() {
                this.$router.push("/FoodClassList");
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
				// if(this.coupon_divide==''&&this.coupon_divide==null){
				//   this.coupon_divide=0;
				// }
                this.$refs.forms.validate().then(() => {
                    var toast = Toast.loading({
                        duration: 0,
                        message: '添加中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
                    this.$http.post('/wechat/api.store_class/addClass', {
                        name: this.name,
						image:this.image,
						rank:this.rank,
                        // openid: window.localStorage.getItem("openid")
                    }).then(response => {
                        toast.clear();
                        if (response && response.data.code== 200) {

                            this.$router.push("/FoodClassList");

                            // VueCookie.set('salesmanInfo', response.data.data, 360000);
                            // window.location.href = that.redirect;

                        }else{
                            Notify({type: 'danger', message: response.data.msg});
                        }
                    })

                }).catch(() => {
                    this.$toast.fail('必填项未填写')
                })
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;




            },
        },
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }

    .van-field >>>.van-field__label{
        width: 30px;
    }
</style>
